import React from 'react';
import styled, { css } from 'styled-components';
import Alert from 'gatsby-theme-core/src/components/alert';

const SuccessAlert = ({ data, successMessage, ...props }) => (
  <Alert {...props} $success>
    {successMessage || 'Het formulier is verstuurd, we nemen zo snel mogelijk contact met u op.'}
  </Alert>
);

export default styled(SuccessAlert)`
  ${({ $horizontal }) => $horizontal && css`
    margin-top: 0;
  `}
`;
